import { React, useState, useEffect } from 'react';
import MenuIcon from '../icons/Menu-Icon.svg';
import StytchLogin from './third-party/StytchLogin';

export default function Header() {
  const [visibility, isVisible] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);
  const [token, setToken] = useState(null);

  let visibilityClass = visibility ? 'flexVisibility' : 'noneVisibility';
  visibilityClass += ' menu';

  const logOut = () => {
    setLoggingIn(false);
    setToken(null);
    localStorage.setItem('token', null);
  };

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const userToken = urlParams.get('token') || null;
    setToken(userToken);
    localStorage.setItem('token', userToken);
  }, []);

  return (
    <header>
      <div className="menuContainer">
        <img
          src={MenuIcon}
          alt="menuIconBtn"
          id="menuIconBtn"
          className="menuIconBtn"
          onClick={() => isVisible(!visibility)}
        />
        <ul className={visibilityClass} id="menu">
          <li>History</li>
          <li>Fav Artists</li>
        </ul>
      </div>
      {token ? (
        <div>
          <p>You are signed in</p>
          <p onClick={logOut}>Log Out</p>
        </div>
      ) : loggingIn ? (
        <form className="loginForm">
          <StytchLogin />
        </form>
      ) : (
        <div className="loginBtn" onClick={() => setLoggingIn(true)}>
          <p>Login</p>
        </div>
      )}
    </header>
  );
}
